export { Hummus, HummusMain, HummusAside, HummusPortal } from './Hummus';
